module.exports = __webpack_public_path__ + "img/instagram.4a8c2347.png";